import { useStageToolbarState } from '../../states/stage-toolbar-state';
import type { IStageToolbarItemRenderArgs } from '../../types';

const CustomNodeItem = () => {
    const customNode = useStageToolbarState()((state) => state.customNode);
    return customNode;
};

export const customNodeItemRender = ({ config, toolbar }: IStageToolbarItemRenderArgs) => {
    if (!config.items.customNode || !toolbar.getItemAvailability('custom-node')) return null;
    return <CustomNodeItem />;
};
